/* src/app/ship/ship-info-add/ship-info-add.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.ship-info-add .form-section-header {
  margin-bottom: 0 !important;
}
.ship-info-add .help-icon {
  width: 15px;
  height: 15px;
  margin: 0 0.5em;
}
.ship-info-add .location-search-trigger {
  float: right;
  clear: both;
  margin-bottom: 1em;
}
.ship-info-add .adult-signature-warning {
  padding-left: 2.25em;
}
.ship-info-add .adult-signature-warning .warning-title {
  display: block;
  font-weight: 700;
  margin-bottom: 0.25em;
}
.ship-info-add .adult-signature-warning .warning-message {
  display: block;
  font-size: 0.75rem;
  padding: 0.5rem;
}
.ship-info-add .ap-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.44rem;
}
.ship-info-add .ap-option a {
  text-decoration: underline;
  font-size: 0.71875rem;
  font-weight: 700;
}
.ship-info-add .access-point {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding: 0.4375rem 0.9375rem;
  border-radius: 0.25rem;
  border: 1px solid #0A8080;
  background: white;
  min-height: 3.125rem;
  column-gap: 0.94rem;
}
.ship-info-add .access-point .ap-title {
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1rem;
  white-space: nowrap;
}
.ship-info-add .access-point .ap-address-wrapper {
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
}
.ship-info-add .access-point .ap-edit {
  position: absolute;
  top: 0.31rem;
  right: 0.9375rem;
  font-size: 0.625rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.25rem;
  text-decoration-line: underline;
  color: #0A8080;
}
.ship-info-add .cod-options {
  padding-top: 1rem;
}
.option-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
/*# sourceMappingURL=ship-info-add.component.css.map */
